import AprovarPesquisaPreco from './componentes/AprovarPesquisaPreco.vue';
import AprovarPesquisaPrecoLista from './componentes/AprovarPesquisaPrecoLista.vue';
import AprovarPesquisaPrecoRelatorio from './componentes/AprovarPesquisaPrecoRelatorio.vue';

export default {
  path: '/aprovar-pesquisa-preco',
  component: AprovarPesquisaPreco,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: AprovarPesquisaPrecoLista,
      name: 'aprovar-pesquisa-preco',
    },
    {
      path: ':id/relatorio',
      component: AprovarPesquisaPrecoRelatorio,
      name: 'aprovar-pesquisa-preco.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/aprovar-pesquisa-preco/rotas.js